import { TFunction } from 'i18next';

// Legacy functions (deprecated - use getValidationMessages instead)
export const REQUIRED_FIELD_MSG = (label: string = 'Field') => `${label} is required`;
export const MINIMUM_CHARACTERS_MSG = (count: number = 2) => `At least ${count} characters`;
export const MAXIMUM_CHARACTERS_MSG = (count: number = 20) => `Maximum ${count} characters`;
export const INVALID_PHONE_MSG = 'Invalid phone number';
export const WRONG_EMAIL_MSG = 'Wrong email address';
export const SOMETHING_WRONG_MSG = 'Something went wrong';

// New i18n-enabled validation messages
export const getValidationMessages = (t: TFunction) => ({
  requiredField: (label?: string) =>
    label ? t('common.validation.required', { label }) : t('common.validation.fieldRequired'),
  minCharacters: (count: number = 2) => t('common.validation.minCharacters', { count }),
  maxCharacters: (count: number = 20) => t('common.validation.maxCharacters', { count }),
  invalidPhone: () => t('common.validation.invalidPhone'),
  wrongEmail: () => t('common.validation.wrongEmail'),
  somethingWrong: () => t('common.validation.somethingWrong'),
  addressMinLength: () => t('common.validation.addressMinLength'),
});
